/**
 * The marketing copy for the signed-out landing page, kept in one place so the wording can be
 * revised without touching layout. The site is live, so the framing is present-tense rather than
 * "coming soon".
 */
export const landingCopy = {
  /** The product name, rendered with an accented second half in the brand mark. */
  brandLead: 'Grease',
  /** The accented tail of the brand mark. */
  brandTail: 'map',
  /** Small kicker above the hero title. */
  eyebrow: 'Now live',
  /** The hero headline. */
  tagline: 'Find the meets. Build the ride.',
  /** The one-line pitch under the headline. */
  pitch: 'Car shows, your garage, and race day — all on one map.',
  /** Label for the primary sign-up action. */
  createAccount: 'Create account',
  /** Label for the sign-in action. */
  signIn: 'Sign in',
  /** Label for the public browse action. */
  browseEvents: 'Browse events',

  /** The three product pillars shown as feature cards. */
  features: [
    {
      key: 'garage',
      title: 'Your garage, online',
      body: 'Log every build, mod, and photo. Keep your whole fleet in one place and show it off.',
    },
    {
      key: 'discover',
      title: 'Find the meets',
      body: 'Car shows, cruise-ins, and meets near you on a live map. RSVP so you never miss one.',
    },
    {
      key: 'racing',
      title: 'Run race day',
      body: 'Host bracket and heat racing with live timing, scoring, and standings.',
    },
  ],

  /** The three onboarding steps. */
  steps: [
    { title: 'Create your account', body: "It's free and takes a minute." },
    { title: 'Build your garage', body: 'Add your rides, mods, and photos.' },
    { title: 'Find events & race day', body: 'Discover meets nearby, or host your own race.' },
  ],

  /** Heading for the live upcoming-events section. */
  upcomingTitle: 'Upcoming events',
  /** Link label taking the visitor to full public discovery. */
  browseAll: 'Browse all events',

  /** The small motif echoed in the footer. */
  footerTagline: 'Garage · Map · Grid',
  /** Placeholder footer links; real destinations land later. */
  footerLinks: [
    { label: 'About', href: '#about' },
    { label: 'Privacy', href: '/privacy' },
    { label: 'Terms', href: '#terms' },
    { label: 'Contact', href: '#contact' },
  ],
} as const;
